<div>
  {{data.deviceName}}
</div>
